import CreateNewForeCaste from '../../../../components/AssetManagement/Overview/PerformanceForecaster/CreateNewForeCast/CreateNewForeCast'

const CreateNewForeCasteScreen = () => {
  return (
    <>
    <CreateNewForeCaste />
    </>
  )
}

export default CreateNewForeCasteScreen